const getPaymentsInfos = async (id, hash) => {
  let payments = {};
  try {
    const url = `${process.env.REACT_APP_DOMAIN_URL}/${process.env.REACT_APP_PAYMENT_URL}/${id}?`;
    const result = await fetch(url + new URLSearchParams({ hash }));
    payments = await result.json();
  } catch (e) {
    // console.error(e);
  }

  return payments;
};

export default getPaymentsInfos;
